<div class="row mgp-content bg-primary-lighten">
    <div class="col-12 col-lg-8 offset-lg-2 p-0 text-center">
        <div class="jumbotron text-white">
            <h1 class="mgp-display-4">Piattaforma per la creazione e il rilascio di progetti Software</h1>
            <p class="lead">La Piattaforma per lo Sviluppo e Rilascio di Componenti Software di Regione Toscana nasce con l'obiettivo di standardizzare il processo di sviluppo e rilascio di progetti Open Source ad uso della Community di utenti di Regione.</p>
        </div>
    </div>
</div>

<!--Jira 1026 Button Link to get projects to be approved-->
<div class="row">
    <div class="col-12 col-lg-8 offset-lg-2 text-center btn-lg btn-outline-danger bg-transparent text-dark ng-star-inserted font-weight-bold border border-danger" *ngIf="isRoleReferente || isDelegated && count != 0" style="border: 3px solid !important;color: red !important;">
            <!--a routerLink="./progetti" class="col-12 col-lg-8 offset-lg-2 text-center btn-lg btn-danger bg-danger text-white" style="border: 3px solid !important;color: red !important;" *ngIf="isRoleReferente && count != 0"-->
                Hai {{count}} progetti in attesa di approvazione. <a class="btn-lg bg-transparent text-dark font-weight-bold" routerLink="./progetti" style="color: red !important;">  Clicca qui per accedere alla lista.</a>
    </div>
    <!--a routerlink="./progetti" routerlinkactive="active" data-cy="projects" class="col-12 col-lg-8 offset-lg-2 text-center btn btn-link btn-lg btn-danger bg-danger text-white" ng-reflect-router-link="./progetti" ng-reflect-router-link-active="active" ng-reflect-router-link-active-options="[object Object]" href="/mgp/progetti" *ngIf="isRoleReferente && count != 0">
        Hai {{count}} progetti in attesa di approvazione. Consulta la lista 
    </a-->
</div>

<div class="row">
    <div class="col-lg-6">
        <div class="card border-0">
            <div class="row g-0">
                <div class="col-md-1 text-center text-md-end pt-2">
                    <fa-icon [icon]="['fab','gitlab']" size="3x" class="text-danger"></fa-icon>
                </div>
                <div class="col-md-11">
                    <div class="card-body">
                        <h2 class="card-title text-center text-md-start">
                            <span>Ultimi tuoi progetti approvati</span>
                        </h2>
                        <div class="spinner-container hide-text" *ngIf="gitlabProjectLoading">
                            <ngx-spinner type="timer" name="projectSpinner" [fullScreen]="false"></ngx-spinner>
                        </div>
                        <ng-container *ngIf="!gitlabProjectLoading">
                            <div class="card-text" *ngIf="gitlabProjects.length === 0">
                                <div class="d-flex justify-content-center py-4">
                                    Nessun progetto trovato
                                </div>
                            </div>
                            <div class="card-text" *ngFor="let sGitlabProject of gitlabProjects">
                                <div class="project d-flex align-items-center flex-column flex-md-row">
                                    <div class="avatar d-none d-md-block" [mgpBackgroundClass]="sGitlabProject.id">
                                        <div class="avatar-content">
                                            <div>{{ sGitlabProject.name.charAt(0).toUpperCase() }}</div>
                                        </div>
                                    </div>
                                    <div class="d-sm-flex flex-sm-fill me-md-2 mb-3 mb-md-0">
                                        <div class="project-desc">
                                            <h4><span>{{ getFullProjectNamespace(sGitlabProject.nameWithNamespace)}} </span><span class="project-name">{{ sGitlabProject.name }}</span></h4>
                                            <div><small>{{ sGitlabProject.description }}</small></div>
                                        </div>
                                    </div>
                                    <a href="{{ sGitlabProject.webUrl }}" target="_blank" rel="noopener noreferrer" class="btn btn-success text-nowrap">Vedi su Oscat</a>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="card border-0">
            <div class="row g-0">
                <div class="col-md-1 text-center text-md-end pt-5 pt-md-2">
                    <fa-icon [icon]="['fas','newspaper']" size="3x" class="text-danger"></fa-icon>
                </div>
                <div class="col-md-11">
                    <div class="card-body">
                        <h2 class="card-title text-center text-md-start">
                            <span>News dalla piattaforma</span>
                        </h2>
                        <ng-container *ngFor="let sNews of news">
                            <div class="news card-text" (click)="openNews(sNews)">
                                <h4>{{ sNews.title }}</h4>
                                <p>{{ sNews.message }}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</div>